import React from 'react';

export default function CardSubTitle({children, ...props}) {
    return <h2 {...props}>{children}</h2>;
}
